/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import axios from 'api/axios'
import { EEIDM_URl, EEIDM_URl_CRM, EEIDM_URl_MANAGER, EEIDM_URl_TC,EEIDM_URl_ORDER  } from './config'
// console.log(`${EEIDM_URl}`,'rrrrrrrrrrrrrrrrrr')
export let FileUrl = `${EEIDM_URl}/eeidm-order/idm/order/orderFileUpload` // 文件上传
export function getAction (url, parameter, author) {
  return axios({
    url: url,
    method: 'get',
    params: parameter,
    headers: {
      'X-Access-Token': author
    }
  })
}

export function postAction (url, parameter, author) {
  return axios({
    url: url,
    method: 'post',
    data: parameter,
    headers: {
      'X-Access-Token': author
    }
  })
}
// deleteAction
export function deleteAction (url, parameter, author) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter,
    headers: {
      'X-Access-Token': author
    }
  })
}

const logout = (params, token) => getAction(`${EEIDM_URl}/eeidm-system/sys/logout`, params, token) // 退出登录
const orderPCBCalcPrice = (params, token) => getAction(`${EEIDM_URl}/eeidm-order/idm/calculate/orderPCBCalcPrice`, params, token) // PCB
const orderSMTCalcPrice = (params, token) => getAction(`${EEIDM_URl}/eeidm-order/idm/calculate/orderSMTCalcPrice`, params, token) // PCBA

const contactsList = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/contacts/list`, params, token) // 联系人列表
const changeContacts = (params, token) => postAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/contacts/changeContacts`, params, token) // 修改技术联系人
const addContacts = (params, token) => postAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/contacts/addContacts`, params, token) // 新增技术联系人
const setDefault = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/contacts/setDefault`, params, token) // 设为默认 技术联系人
const deleteContact = (params, token) => deleteAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/contacts/delete`, params, token) // 删除 技术联系人

const shpgaddList = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/shpgadd/list`, params, token) // 收货地址列表
const shpgChange = (params, token) => postAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/shpgadd/change`, params, token) // 收货地址修改
const shpgaddChange = (params, token) => postAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/shpgadd/addShpgad`, params, token) // 收货地址新增
const shpgDelete = (params, token) => deleteAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/shpgadd/delete`, params, token) // 收货地址删除
const shpgsetDefault = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust${EEIDM_URl_MANAGER}/shpgadd/setDefault`, params, token) // 收货地址默认
// const changeOrderShippingAddress = (params, token) => getAction(`/eeidm-demo/kbidm/order/changeOrderShippingAddress`, params, token) // 确认修改地址

const orderSave = (params, token) => postAction(`${EEIDM_URl}/eeidm-order/idm/order/orderSave`, params, token) // 订单下单

const queryCustomerList = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust/manage/queryCustomerList`, params, token) // 客户列表 --- 代客下单
const queryCustomerById = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/cust/manage/queryCustomerById`, params, token) // 客户列表 --- 代客下单
const findList = (params, token) => getAction(`${EEIDM_URl}/eeidm-order/idm/asset/manage/billingApply/findList`, params, token) // 开票列表 --- 代客下单
const getOne = (params, token) => getAction(`${EEIDM_URl}/eeidm-order/idm/asset/manage/billingApply/getOne`, params, token) // 开票详情 --- 代客下单

const businessOpportunity = (params, token) => postAction(`${EEIDM_URl_ORDER}/eeidm-supplier/businessOpportunity/update `, params, token) // 线索管理
const currentList = (params, token) => getAction(`${EEIDM_URl}/eeidm-system/sys/platform/current/list`, params, token) // 获取用户权限列表
// ${EEIDM_URl_TC}
const userInfo = (params, token) => getAction(`/eeidm-order/idm/overview/getWallet`, params, token) // 获取用户余额
const orderList = (params, token) => getAction(`/eeidm-order/idm/overview/orderList?orderType=0&pageSize=3`, params, token) // 获取用户订单信息
const orderListDes = (params, token) => getAction(`/eeidm-order/idm/overview/orderList?orderType=8&pageSize=3`, params, token) // 获取用户订单信息

const queryUserRoleCode = (params, token) => getAction(`${EEIDM_URl}/eeidm-system/sys/user/queryUserRoleCode`, params, token) // 获取用户角色集

const getPcbDeliveryDays = (params, token) => getAction(`${EEIDM_URl}/eeidm-order/idm/calculate/getDeliveryDays`, params, token) // 新单-获取PCB订单交期

const getbyCustomer = (params, token) => getAction(`${EEIDM_URl}/eeidm-customer/protocol/quote/details/byCustomer`, params, token) // 协议价格详情 --- pcb

export { userInfo,orderList,orderListDes,currentList,logout, getbyCustomer, queryUserRoleCode, getPcbDeliveryDays, businessOpportunity, orderPCBCalcPrice, findList, getOne, queryCustomerById, orderSMTCalcPrice, contactsList, changeContacts, addContacts, setDefault, deleteContact, shpgaddList, shpgChange, shpgaddChange, shpgDelete, shpgsetDefault, orderSave, queryCustomerList }




// WEBPACK FOOTER //
// ./src/api/orderNew.js